/** Parses an error message to a human readable form if message contains JSON syntax */
export default function parseErrorMessage(message) {
  if (message.match(/^{.*}$/)) {
    const parsedMsg = JSON.parse(message)
    return Object.entries(parsedMsg)
      .map(([key, value]) => `<strong>${key}</strong>: ${value}`)
      .join('</br>')
  }
  return message
}
